import { Field } from 'components/Wizards/Field/Field'
import { Input } from 'almanac-ui/TextInputField/Input'
import { useEffect, useState } from 'react'
import { Text } from 'blaze-ui/Text/Text'

type Props = {
  details?: string
  onUpdate: (details: string) => void
}

const RepresentationDetails = ({ details, onUpdate }: Props) => {
  const [stagedValue, setStagedValue] = useState(details || '')

  useEffect(() => {
    if (details) {
      setStagedValue(details)
    }
  }, [details])

  return (
    <Field label={<Label />} labelType="label" data-testid="representation-details">
      <Input
        name="representation-details"
        isTextarea
        aria-label="Additional details"
        value={stagedValue}
        onChange={(e) => setStagedValue(e.target.value)}
        placeholder="Describe cultural cues, style, or context to guide representation"
        rows={3}
        size="lg"
        onBlur={() => onUpdate(stagedValue)}
      />
      <Text variant="metadata" color="var(--dark-40)">
        We’ll do our best to reflect this in your content. Some results may vary across formats.
      </Text>
    </Field>
  )
}

const Label = () => (
  <Text variant="label" color="var(--dark-60)">
    Additional details (optional)
  </Text>
)

export { RepresentationDetails }
